<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="backdrop-area" @click="hide()"></div>
            <div class="modal-content bg-a-egg-f5ebdc">
                <div class="w-full h-full p-4 text-center text-a-brown-502314 flex">
                    <div class="m-auto w-full max-content-modal">
                        <div class="font-bold pb-6 lg:text-24">{{lbl.shoppingcart.popup_qr_payment.title}}</div>
                        <div class="bg-a-brown-e9dac5 py-6 mb-4 font-bold lg:text-18 rounded-10">{{ getPriceText() }}</div>
                        <div class="w-full background-qr rounded-20 p-5 ">
                            <div class="flex pb-2">
                                <img class="m-auto h-12" src="@/assets/shopping_cart/logo-promptpay.png" />
                            </div>
                            <div class="text-12 pb-4">{{lbl.shoppingcart.popup_qr_payment.transaction_date}} {{FilterDateTimeFormat(getCurrentDateTime())}}</div>
                            <div class="flex pb-4">
                                <img class="m-auto h-72" :src="qrUrl" />
                            </div>
                            <div class="text-14">{{lbl.shoppingcart.popup_qr_payment.qr_time}} {{ displayTime }}</div>
                        </div>
                        <div class="text-14 lg:text-16 py-4 lg:py-6">{{lbl.shoppingcart.popup_qr_payment.scan_qr_to_pay}} </div>
                        <div class="w-full flex pt-4">
                            <RedButton customClass="w-64 py-2.5 m-auto lg:text-18"
                                @click="clickOk()">{{btnOk}}</RedButton>
                        </div>
                        <div class="w-full flex pt-4">
                            <WhiteButton customClass="w-64 py-2.5 m-auto font-bold lg:text-18"
                                @click="clickCancel()">{{btnCancel}}</WhiteButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
//config
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from "@/helper/CacheHelper";
import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper"
import LocaleMixin from "@/mixin/LocaleMixin.js";
import DatetimeHelper from "@/helper/DatetimeHelper";
//component
import RedButton from '@/components/Button/RedButton.vue';
import WhiteButton from '@/components/Button/WhiteButton.vue';
//facade
import SendFunction from '@/helper/facade/SendFunction';
export default {
    name: "QRPaymentModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        RedButton,
        WhiteButton
    },
    data: function() {
        return {
            open: false,

            timer: new TimerHelper(),
            sendFunction: new SendFunction(),
            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            expireIn: 180,
            displayTime: '',
            qrUrl: '',
            total: 1000,
            isExpireTime: false,
            checkReload: false,

            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timer.initialTimer(this.expireIn, ':', false, false);
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.qrUrl = config.qrUrl;
            this.expireIn = config.expireIn;
            this.total = config.total;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.checkReload = config.checkReload;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.startTimeQr()
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            // this.hide();
            this.clickSaveQr();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickSaveQr: function() {
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache('return_url');
            if (cacheReturnUrl) {
                if (Util.isIOSDevice()) {
                    this.sendFunction.saveIOS(this.qrUrl);
                } else {
                    this.sendFunction.saveAndroid(this.qrUrl);
                } 
            } else {
                Util.saveImage(this.qrUrl, 'qr-payment.png');
            }
        },
        getPriceText: function() {
            return this.FilterStringFormat(this.lbl.shoppingcart.popup_qr_payment.total,this.FilterNumberFormat(this.total)) 
        },
        getCurrentDateTime: function() {
            return DatetimeHelper.convertDateToTimeStampUnix(new Date());
        },
        //#region time otp
        startTimeQr: function() {
            this.isExpireTime = false;
            this.timer.setExpireIn(this.expireIn);
            this.timer.runTimer((displayTime) => {
                this.displayTime = displayTime;
            }, () => {
                this.onQrTimeExpire();
            })
        },
        
        onQrTimeExpire: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.isExpireTime = true;
        },
        //#endregion time otp
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 100vw;
            height: 100vh;
        }

        .max-content-modal {
            max-width: 358px;
        }

        .background-qr {
            background-image: url("../../../../assets/shopping_cart/bg-qrpayment.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-color: #ffffff;
            
        }
    }
</style>
